import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface PublicRouteProps {
  children: ReactNode;
  isAuthenticated: boolean;
  isInitialized: boolean;
  redirectTo?: string;
}

export function PublicRoute({ children, isAuthenticated, isInitialized, redirectTo = "/additional/memo" }: PublicRouteProps) {
  // 초기화 중일 때는 로딩 표시
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">로딩 중...</p>
        </div>
      </div>
    );
  }

  // 이미 인증된 경우 지정된 페이지로 리다이렉트
  if (isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
